import React, { useState, useEffect, useCallback } from 'react';
import styles from './HeroSection.module.css';
import { FiChevronLeft, FiChevronRight } from 'react-icons/fi';
import { motion, AnimatePresence } from 'framer-motion';
import SplashScreen from '../../SplashScreen/SplashScreen';

const HeroSection = () => {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setLoading(false);
    }, 1000); // 1.0 seconds duration

    return () => clearTimeout(timer);
  }, []);

  const slides = [
    { id: 1, url: '/images/hero-section/hero222.jpg' },
    { id: 2, url: '/images/hero-section/hero111.jpg' },
    { id: 3, url: '/images/hero-section/hero123.jpeg' },
    { id: 4, url: '/images/hero-section/hero44.jpg' },
    { id: 5, url: '/images/hero-section/hero789.jpeg' },
    { id: 6, url: '/images/hero-section/hero55.webp' },
    { id: 7, url: '/images/hero-section/hero77.jpg' },
    { id: 8, url: '/images/hero-section/hero99.jpg' }
  ];

  const [currentIndex, setCurrentIndex] = useState(0);

  const nextSlide = useCallback(() => setCurrentIndex((prev) => (prev === slides.length - 1 ? 0 : prev + 1)), [slides.length]);
  const prevSlide = () => setCurrentIndex((prev) => (prev === 0 ? slides.length - 1 : prev - 1));

  useEffect(() => {
    const timer = setInterval(nextSlide, 5000);
    return () => clearInterval(timer);
  }, [nextSlide]);

  return (
    <section className={styles.heroContainer}>
      {loading && <SplashScreen />}

      <div className={styles.slideWrapper}>
        <AnimatePresence>
          <motion.img
            key={slides[currentIndex].id}
            src={slides[currentIndex].url}
            alt={`Slide ${slides[currentIndex].id}`}
            className={styles.heroImage}
            style={{
              transform: `scale(${slides[currentIndex].scale})`,
              objectPosition: slides[currentIndex].position
            }}
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 1 }}
          />
        </AnimatePresence>

        <div className={styles.overlay} />

        <button className={`${styles.navBtn} ${styles.left}`} onClick={prevSlide}>
          <FiChevronLeft />
        </button>
        <button className={`${styles.navBtn} ${styles.right}`} onClick={nextSlide}>
          <FiChevronRight />
        </button>
      </div>
    </section>
  );
};

export default HeroSection;